import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteObjektArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteObjektArtCommandService],
  exports: []
})
export class DeleteObjektArtCommandServiceModule { }
